import {
  Card,
  FormControlLabel,
  Stack,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import { ServiceCode } from './service-code'
import { MaskedInput } from '@/components/masked-input'
import { useFormContext } from 'react-hook-form'
import { FiscalNoteFormData } from '../schema'
import { Controller } from 'react-hook-form'
import { CNAE } from './cnae'
import { InfoOutlined } from '@mui/icons-material'
import { Municipality } from './municipality'
import { useCompany } from '@/context/companies'
import { Taxes } from './taxes/taxes'
import { useEffect } from 'react'
import {
  applyTaxesText,
  isSimpleNationalCompany,
  stripTaxesText,
} from '@/helpers'

export function FiscalNoteData() {
  const { control, watch, getValues, setValue } =
    useFormContext<FiscalNoteFormData>()

  const { company } = useCompany()

  const borrower = watch('borrower')
  const value = watch('value')
  const isSimpleNational = isSimpleNationalCompany(company)

  useEffect(() => {
    const description = getValues('description') ?? ''
    const nextDescription = isSimpleNational
      ? applyTaxesText(description, value)
      : stripTaxesText(description)

    if (nextDescription !== description) {
      setValue('description', nextDescription)
    }
  }, [value, isSimpleNational, getValues, setValue])

  return (
    <Card>
      <Typography variant="h5" mb={1}>
        Informações da nota
      </Typography>

      <Stack spacing={2}>
        <Controller
          control={control}
          name="value"
          render={({ field, formState: { errors } }) => (
            <MaskedInput
              label="Valor"
              format="currency"
              error={!!errors.value}
              helperText={errors.value?.message}
              data-testid="value"
              {...field}
            />
          )}
        />

        <ServiceCode companyKey={company.key} />

        <CNAE cnaes={company.cnae_companies} />

        <Controller
          control={control}
          name="description"
          render={({ field, formState: { errors } }) => (
            <TextField
              label="Descrição"
              multiline
              rows={4}
              error={!!errors.description}
              helperText={errors.description?.message}
              data-testid="description"
              {...field}
            />
          )}
        />

        {borrower?.tax_id_type === 'cnpj' && (
          <Controller
            control={control}
            name="iss_retention"
            render={({ field }) => (
              <FormControlLabel
                data-testid="iss-retention"
                control={<Switch checked={field.value} {...field} />}
                label={
                  <Stack direction="row" alignItems="center" gap={1}>
                    ISS retido pelo cliente?
                    <Tooltip title="ISS pago pelo tomador do serviço. Consulte a lei do município.">
                      <InfoOutlined fontSize="small" />
                    </Tooltip>
                  </Stack>
                }
              />
            )}
          />
        )}

        <Municipality />

        <Taxes />
      </Stack>
    </Card>
  )
}
